import * as React from 'react';
import {FormikProps} from 'formik';
import ChatInput from '../../../components/ChatUI/ChatInput';

export interface FormValues {
  message: string;
}

export default class ChatFormBase extends React.Component<FormikProps<FormValues>, {}> {
  public render() {
    const {values, handleChange, handleBlur, handleSubmit} = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <ChatInput
          id="message"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.message}
          placeholder="Enter your message"
        />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ChatForm/private/ChatFormBase.tsx